export enum BonusType {
    MAIN = 'mainBonus',
    MAIN_MEGA = 'mainMega',
    ALPHA = 'sideAlpha',
    BETA = 'sideBeta',
}
